import React from 'react';
import { BookOpen, PieChart, GraduationCap, LifeBuoy } from 'lucide-react';
export function Services() {
  const services = [{
    title: 'Beginner Investment Plans',
    description: 'Start with as little as 500 PLN. We help you choose safe, diversified funds perfect for getting started.',
    icon: PieChart
  }, {
    title: 'Educational Workshops',
    description: 'Weekend group sessions in Zakopane where we demystify the stock market and savings accounts.',
    icon: GraduationCap
  }, {
    title: 'Portfolio Building',
    description: 'Ready for the next step? We help you diversify into bonds, ETFs, and stable local stocks.',
    icon: BookOpen
  }, {
    title: 'Ongoing Guidance',
    description: 'Quarterly check-ins to review your progress and adjust your strategy as your life changes.',
    icon: LifeBuoy
  }];
  return <section id="services" className="py-24 bg-emerald-50" data-id="element-121">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-122">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-123">
          <div data-id="element-124">
            <h2 className="text-emerald-600 font-semibold tracking-wide uppercase text-sm mb-2" data-id="element-125">
              Our Services
            </h2>
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-126">
              Everything you need to start growing your money
            </h3>
            <p className="text-lg text-gray-600 mb-8" data-id="element-127">
              We don't just manage money; we teach you how to understand it. Our
              services are designed to take you from "confused" to "confident."
            </p>

            <div className="bg-white p-6 rounded-2xl shadow-sm border border-emerald-100" data-id="element-128">
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-129">Did you know?</h4>
              <p className="text-gray-600 text-sm" data-id="element-130">
                The best time to plant a tree was 20 years ago. The second best
                time is now. The same applies to investing.
              </p>
            </div>
          </div>

          <div className="grid sm:grid-cols-2 gap-6" data-id="element-131">
            {services.map((service, index) => <div key={index} className="bg-white p-6 rounded-2xl shadow-sm hover:shadow-md transition-shadow border border-gray-100 group" data-id="element-132">
                <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center mb-4 group-hover:bg-emerald-600 transition-colors duration-300" data-id="element-133">
                  <service.icon className="h-6 w-6 text-emerald-600 group-hover:text-white transition-colors duration-300" data-id="element-134" />
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-2" data-id="element-135">
                  {service.title}
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-136">
                  {service.description}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}